import { useState } from 'react';
import { Dropdown, DropdownItem, DropdownToggle } from '@patternfly/react-core';
import { faBook, faInfoCircle, faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMount } from 'react-use';
import { useApplication } from '../../components/user/ApplicationProvider';
import { ZoneSettingEnum } from '../../api/zone/ZoneSetting';

export default function SiteHelpIcon() {
	const { zoneSettings } = useApplication();

	const [isOpen, setIsOpen] = useState(false);
	const [helpLinkUrl, setHelpLinkUrl] = useState<string>();
	const [externalServiceUrl, setExternalServiceUrl] = useState<string | null>();
	const currentApplicationButtonColor = localStorage.getItem('AppBranding_ButtonColor');

	useMount(() => {
		const helpSetting = zoneSettings.find(
			(x) => x.zone_setting_enum_id === ZoneSettingEnum.SiteHelpUrl
		);
		const externalSetting = zoneSettings.find(
			(x) => x.zone_setting_enum_id === ZoneSettingEnum.ExternalServiceHelpUrl
		);

		if (helpSetting?.enabled && helpSetting.value) setHelpLinkUrl(helpSetting.value);
		if (externalSetting?.enabled && externalSetting.value)
			setExternalServiceUrl(externalSetting.value);
	});

	const handleOpenInNewTab = (url?: string) => {
		window.open(url ?? 'https://docs.zeroedin-dev.com', '_blank', 'noopener,noreferrer');
		setIsOpen(false);
	};

	const items = [
		<DropdownItem
			key="online-docs"
			onClick={() => handleOpenInNewTab(helpLinkUrl)}
		>
			<FontAwesomeIcon icon={faInfoCircle} /> Online Documentation
		</DropdownItem>,
		externalServiceUrl && (
			<DropdownItem
				key="jira-service"
				onClick={() => handleOpenInNewTab(externalServiceUrl)}
			>
				<FontAwesomeIcon icon={faBook} /> Get Support
			</DropdownItem>
		),
	].filter(Boolean);

	return (
		<Dropdown
			isOpen={isOpen}
			onSelect={() => setIsOpen(false)}
			position="right"
			className="dropdownHelpIcon no-color-override"
			isText
			isPlain
			toggle={
				<DropdownToggle
					toggleIndicator={null}
					onToggle={() => setIsOpen((prev) => !prev)}
					aria-label="Help"
					className="no-color-override"
					icon={
						<FontAwesomeIcon
							icon={faQuestionCircle}
							style={{
								width: '2rem',
								height: '1.5rem',
								cursor: 'pointer',
								position: 'relative',
								right: '3px',
								color: 'black',
								background: '#d2d2d2',
							}}
						/>
					}
				/>
			}
			dropdownItems={items}
		/>
	);
}
